import React, { useState, useEffect, useRef } from "react";
import { motion } from 'framer-motion';
import { SlideInWithScroll } from "../utils/animations/slideInWithScroll";

export default function TechnologyColumn(props) {

  const { items, classes } = props.data;
  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const [clientWidth, setClientWidth] = useState(0);
  const ref = useRef();
  let triggers = [[0.90, 0.85], [0.80, 0.65], [0.70, 0.55], [0.60, 0.45]];
  if (clientWidth < 1681) {
    triggers = [[1, 0.85], [0.90, 0.75], [0.8, 0.65], [0.7, 0.55]];
  }

  const setValues = () => {
    setElementTop(ref.current.offsetTop);
    setClientHeight(window.innerHeight);
    setClientWidth(window.innerWidth);
  };

  useEffect(() => {
    if (!ref.current) return;
    props.isLoaded && setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  });

  return (
    <>
      <div ref={ref} className={`grid-layout-section mobile-full-width section-gap-small ${classes}`} id={props.id ? props.id : ''} onLoad={setValues}>
        <div className="container">
          <div className="row d-flex flex-wrap">
            {items.map((item, index) => {
              const jsx = (<motion.div key={index} className="col grid-item">
                <div className="item-inner">
                  <div className="grid-icon">
                    <i>{item.icon}</i>
                  </div>
                  <div className="grid-item-content">
                    <h3>{item.header}</h3>
                    <p>{item.content}</p>
                  </div>
                </div>
              </motion.div>);
              return <SlideInWithScroll elementTop={elementTop} clientHeight={clientHeight} children={jsx} triggerPoints={triggers[index]} key={index} />;
            })}
          </div>
        </div>
      </div>
    </>
  );
}